<!-- filepath: /src/app/components/loader/loader.component.html -->
<div *ngIf="loadings" class="loader-overlay">
  <div class="loader"></div>
</div>